import React, { useState } from 'react';

function OgIgnoredClients({ ids, canEdit, onEdit }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="og-ignored">
      <button type="button" className={'ig-bar' + (open ? ' open' : '')} onClick={() => setOpen((o) => !o)}>
        <div className="igt">
          <b>Ignored Clients</b>
          <span>Apollo IDs excluded from billing &amp; automation</span>
        </div>
        <div className="sp" />
        <span className="cnt">{ids.length} IDs</span>
        <span className="chev">
          <i className="fa-solid fa-chevron-down" />
        </span>
      </button>
      {open ? (
        <div className="ig-body">
          <div className="id-chips">
            {ids.map((id) => (
              <span key={id} className="chip idc">
                {id}
              </span>
            ))}
          </div>
          {canEdit ? (
            <button type="button" className="btn navy sm" onClick={onEdit}>
              <i className="fa-solid fa-pen" /> Add / Remove Ignored Client
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}

export default OgIgnoredClients;
